import * as React from 'react'
import { withApplication } from '../components'

export const AboutComponent = () => withApplication(<div>アバウト</div>)
